import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalActionProps } from 'models/AutoModals';
import { ListItemLink } from 'components/mui/ListItemLink';
import { PartyModel } from 'models/PartyModel';
import {
    Box,
    Button,
    DialogActions,
    DialogContent,
    Grid,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Radio,
} from '@mui/material';
import { Person } from '@mui/icons-material';
import { CarModel } from 'models/StockModel';
import useCars from 'modules/cars/hooks/useCars';
import { removeItemAtIndex } from 'utils/common';


type MergePartiesDialogProps = {
    parties: PartyModel[],
} & ModalActionProps<number[]>;

const MergePartiesDialog = ({parties, onFinish}: MergePartiesDialogProps) => {
    const {t} = useTranslation();
    const [main, setMain] = useState(0);
    const [cars, setCars] = useState<CarModel[]>([]);
    const {findCars} = useCars();

    useEffect(() => {
        findCars({parties: parties.map(p => p.id)})
            .then(res => setCars(res.data));

        const controlled = parties.findIndex(p => p.manager);
        if (controlled > 0)
            setMain(controlled);
        // eslint-disable-next-line
    }, []);

    const submit = () => {
        const ids = [
            parties[main].id,
            ...removeItemAtIndex(parties.map(p => p.id), main),
        ];
        onFinish(ids);
    };

    return (
        <>
            <DialogContent>
                <Grid container>
                    <Grid item sm={8}>
                        <Box textAlign="center">{t('select_main_party')}</Box>
                        <List dense>
                            {parties.map((p, i) => {
                                const labelId = `label-${p.id}`;

                                let label = p.name;
                                label += ` ${p.email || ''} ${p.phone || ''}`;

                                return (
                                    <ListItem
                                        key={p.id}
                                        disablePadding
                                    >
                                        <ListItemButton
                                            onClick={() => setMain(i)}
                                            dense
                                        >
                                            <ListItemIcon>
                                                <Radio
                                                    edge="start"
                                                    checked={i === main}
                                                    tabIndex={-1}
                                                    disableRipple
                                                    inputProps={{'aria-labelledby': labelId}}
                                                />
                                            </ListItemIcon>
                                            <ListItemText
                                                id={labelId}
                                                primary={<>{p.manager && <Person
                                                    color="success"
                                                    fontSize="small"
                                                    sx={{verticalAlign: 'middle'}}
                                                />} {label}</>}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                );
                            })}
                        </List>
                    </Grid>
                    <Grid item sm={4}>
                        <Box textAlign="center" color="text.disabled">{t('related_cars')}</Box>
                        <List dense>
                            {cars.map(c => (
                                <ListItemLink
                                    key={c.id}
                                    to={`/car/${c.id}`}
                                    primary={`${c.model} ${c.chassisNumber}`}
                                />
                            ))}
                        </List>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button onClick={submit}>
                    {t('apply')}
                </Button>
            </DialogActions>
        </>
    );
};

export default MergePartiesDialog;
